import { ICreateItemChecklistServicoUseCase } from "../../../presentation/useCases/create/create_item_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateItemChecklistServicoUseCase
 */

export class CreateItemChecklistServicoUseCase implements ICreateItemChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createItemChecklistServico(
    idChecklistServico: number,
    ordem: string,
    descricao: string,
    resumoItem: string | null,
    metodoVerificacao: string | null,
    tolerancia: string | null,
  ): Promise<void> {
    await this.repository.createItemChecklistServico(
      idChecklistServico,
      ordem,
      descricao,
      resumoItem ?? '',
      metodoVerificacao,
      tolerancia,
    );
  }
}
